import { Navigate, useRoutes, useLocation } from "react-router-dom";
// layouts
import HomeLayout from "./layouts/HomeLayout";
import Formulaire from "./pages/Formulaire";
import Home from "./pages/Home";

// ----------------------------------------------------------------------

export default function Router() {
  const location = useLocation();
  return useRoutes([
    {
      path: "/",
      element: <HomeLayout />,
      children: [
        { path: "/", element: <Home /> },
        { path: "/formulaire", element: <Formulaire /> },
        // { path: "dashboard", element: <DashboardApp /> },
        // { path: "users", element: <User /> },
        // { path: "company", element: <Company /> },
        // { path: "profile", element: <Profile /> },
      ],
    },
    // {
    //   path: "*",
    //   element: <Navigate to="/404" state={{ from: location }} replace />,
    // },
  ]);
}
